import {request} from './request'


export function getIndexNumber() {
    return request({
        url: '/hp/index/',
        params: {

        }
    });
}

export function getIndexDdianZanNumber(get_number=1) {
    return request({
        url: '/hp/index/dianzan/',
        params: {
            get_number,
        }
    });
}


